import { get, post } from "./http";

// Mirrors ordr-flutter Repository closed-market calls
export const getBuyerQuotation = () => get("/buyer/closed-market/quotation");
export const createClosedMarketOrder = (payload) => post("/buyer/closed-market/order", payload);
export const getClosedMarketOrders = (status = "pending") => get("/buyer/closed-market/orders", { status });
export const getClosedMarketOrderById = (orderId) => get(`/buyer/closed-market/order/${orderId}`);
export const requestNewQuotation = (payload) => post("/buyer/closed-market/request-quotation", payload);
// payload: { note, products: [...] }
